import Vue from "vue";
import VueRouter from "vue-router";
// import LoginPage from "./../views/LoginPage";

import AccessPage from "./../views/AccessPage/AccessPage";
import TheLogin from "./../views/AccessPage/TheLogin";
import ThePassword from "./../views/AccessPage/ThePassword";
import TheRegistration from "./../views/AccessPage/TheRegistration";

import ChangePassword from "./../views/ChangePassword";
import ConfermaUtente from "./../views/ConfermaUtente";
import NotFound from "./../views/NotFound";

Vue.use(VueRouter);

const routes = [
  { path: '/', redirect: '/account/data', meta: { requiresAuthenticated: true }},
  // { path: '/login', component: LoginPage, meta: { requiresUnauthenticated: true } },
  {
    path: '/login',
    component: AccessPage,
    meta: { from: "agency" },
    children: [
      {
        path: "",
        component: TheLogin,
      
        meta: {
          requiresUnauthenticated: true,
          from: "agency"
        },
      },  
      {
        path: "registration",
        component: TheRegistration,
        meta: {
          requiresUnauthenticated: true,
          from: "agency"
        },
      },  
      {
        path: "password",
        component: ThePassword,
        meta: { requiresUnauthenticated: true },
      },  
    ]
  },
  {
    path: '/login-models',
    component: AccessPage,
    meta: { from: "models" },
    children: [
      {
        path: "",
        component: TheLogin,
      
        meta: {
          requiresUnauthenticated: true,
          from: "models"
        },
      },  
      {
        path: "registration",
        component: TheRegistration,
        meta: {
          requiresUnauthenticated: true,
          from: "models"
        },
      },  
      {
        path: "password",
        component: ThePassword,
        meta: { requiresUnauthenticated: true },
      },  
    ]
  },
  { path: '/cambia-password', component: ChangePassword, meta: { requiresUnauthenticated: true } },
  { path: '/conferma-email', component: ConfermaUtente, meta: { requiresUnauthenticated: true } },
  { path: '*', component: NotFound, redirect: '/account/data', }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { y: 0 }
  },
});

import store from "../store/index.js";
router.beforeEach( async (to, from, next) => {
  console.log("TO",to.path);
  console.log("AUTH",store.getters.isAuthenticated);

  if(to.path == "/conferma-email"){
    next();
    return
  }

  if(!store.getters.isAuthenticated && store.getters.try_login_one_time == false){
    let res = await store.dispatch('tryLogin')
    console.log("RES",res);
  
    
    await store.dispatch("user/loadUser");    
    store.commit("try_login_one_time", true);
  }

  if ( to.meta.requiresUnauthenticated && store.getters.isAuthenticated ) {
    console.log("R1");
    next("/account/data");
  } else if( to.meta.requiresAuthenticated && !store.getters.isAuthenticated) {

    next('/login?target='+to.path);
  } else {
    console.log("R3");
    
    // if(to.path.includes("works") || to.path.includes("proposals")){
    //   next('/account/data');
    //   return
    // }
    store.commit("main_loader", false);
    next();
  }
  
})

export default router;
